import { useState } from "react";
import MeetingStatusInfo from "../MeetingStatusInfo";
import { Button } from "@powerdiary/components-library/lib";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { DateTime } from "luxon";
import { MobileHelper } from "common.ui/Helpers/mobile";
import { useClientPortalConfigContext } from "../../../context/ClientPortalConfig.ctx";
import { useTelehealthZoomUrls } from "./useTelehealthZoomUrls";
import { useJoinTelehealth } from "./useJoinTelehealth";

interface IProps {
    startDate: string;
    roomId: string;
}

function isUTCTimeNowGreaterThan(utcTimeString: string): boolean {
    const utcTime = DateTime.fromISO(utcTimeString, { zone: "utc" });
    const nowUTC = DateTime.utc();

    return nowUTC > utcTime;
}

export default function ActionButtonsSection({ roomId, startDate }: Readonly<IProps>) {
    const theme = useTheme();
    const isMobileView = useMediaQuery(theme.breakpoints.down("sm"));
    const isMobileDevice = MobileHelper.isMobileDevice;
    const { clientPortalGuid } = useClientPortalConfigContext();

    const [shouldDisableButtons, setShouldDisableButtons] = useState(false);

    const { refetch } = useTelehealthZoomUrls(clientPortalGuid, { roomId, isMobile: isMobileDevice });

    const { joinInApp, joinInBrowser } = useJoinTelehealth({
        refetch,
        isMobile: isMobileDevice,
        onBusyChange: setShouldDisableButtons,
        roomId,
    });

    return (
        <Box data-test-id="box_joining_action_buttons">
            <MeetingStatusInfo
                startDate={startDate}
                isMeetingUrlAvailable={!shouldDisableButtons}
                isMeetingTime={isUTCTimeNowGreaterThan(startDate)}
            />

            <Box
                display="flex"
                gap="15px"
                alignItems="center"
                justifyContent="center"
                marginTop="8px"
                flexDirection={isMobileView ? "column" : "row"}
                width="100%"
            >
                <Button
                    variant="outlined"
                    onClick={() => {
                        void joinInBrowser();
                    }}
                    disabled={shouldDisableButtons}
                    data-test-id="button_join_in_browser"
                    sx={{ width: isMobileView ? "100%" : "auto" }}
                >
                    JOIN IN BROWSER
                </Button>

                <Button
                    variant="contained"
                    onClick={() => {
                        void joinInApp();
                    }}
                    disabled={shouldDisableButtons}
                    data-test-id="button_join_in_app"
                    sx={{ width: isMobileView ? "100%" : "auto" }}
                >
                    JOIN WITH APP
                </Button>
            </Box>
        </Box>
    );
}
